import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  testSquareMenu: {
    position: 'absolute',
    top: ({ pixelPosition }) => (pixelPosition ? `${pixelPosition.y - 0}px` : 0),
    left: ({ pixelPosition }) => (pixelPosition ? `${pixelPosition.x - 48}px` : 0),
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
    borderRadius: theme.shape.borderRadius,
  },
  testSquareSetButton: {
    position: 'absolute',
    top: ({ pixelPosition }) => (pixelPosition ? `${pixelPosition.y - 0}px` : 0),
    left: ({ pixelPosition }) => (pixelPosition ? `${pixelPosition.x - 48}px` : 0),
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
    minWidth: 'auto',
    padding: theme.spacing(0.5, 2),
    textTransform: 'none',
    boxShadow: theme.shadows[1],
  },
  disabledMenuItem: {
    opacity: 0.5,
    color: theme.palette.text.disabled,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:active': {
      pointerEvents: 'none',
    },
  },
}));
